import React from 'react';
import { Box, styled, Theme } from '@material-ui/core';
import { AccountBalance } from '@material-ui/icons';

const OFFSET = '🇦'.codePointAt(0)! - 'A'.codePointAt(0)!;
function countryToUnicodeFlag(text) {
  return text
    .split('')
    .map(c => String.fromCodePoint(c.codePointAt(0) + OFFSET))
    .join('');
}

const FlagBadge = styled(Box)<Theme, { country: string }>(
  ({ theme, country }) => ({
    '&': {
      position: 'relative',
      marginRight: '1ch',
    },
    '&::before': {
      content: JSON.stringify(countryToUnicodeFlag(country)),
      position: 'absolute',
      right: '-1ch',
      top: '-1ch',
      textShadow: `-2px 2px var(--header-background)`,
    },
  }),
);

/**
 * Render a bank icon (AccountBalance from mui) with the provided country flag underneath
 *
 * Country should be provided as a valid 2 digit code, and will be converted to a flag by converting each character to a regional indicator
 */
export function HeaderIcon({ country }: { country: string }) {
  return (
    <FlagBadge country={country}>
      <AccountBalance />
    </FlagBadge>
  );
}
